<!-- 作业 -->
<template>
    <div>
      <div class="course_Homework">
        <el-row class="content_block">
          <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 400px;overflow: auto;">
            <el-tab-pane label="题库作业" name="HOMEWORK_QUESTION">
              <el-row>
                <el-table
                  :data="tableData"
                  border
                  style="width: 100%">
                  <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingName" header-align="center" align="center" label="题库作业名称"> </el-table-column>
                  <el-table-column prop="avgScore" header-align="center" align="center" label="平均得分"  width="100"> </el-table-column>
                  <el-table-column prop="avgPassRate" header-align="center" align="center" label="及格率"  width="100"> </el-table-column>
                  <el-table-column prop="time" header-align="center" align="center" label="作业时间">
                    <template slot-scope="scope">
                        {{scope.row.teacherOpenCourseQuestionStartTime}} ~ {{scope.row.teacherOpenCourseQuestionEndTime}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="finishTime" header-align="center" align="center" label="完成时间"  width="120"> </el-table-column>
                  <el-table-column prop="myScore" header-align="center" align="center" label="我的得分"  width="120"> </el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingPushStatusText" header-align="center" align="center" label="状态" width="120">
                    <template slot-scope="scope">
                      <span :class="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?'':'red'">
                        {{scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?"发布":"未发布"}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="200">
                    <template slot-scope="scope">
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="startHomework(scope.row)">开始作业</el-link>
                      <el-link type="primary" :underline="false" @click="homeworkDetails(scope.row)">作业成绩详情</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-sizes="[8, 20, 50, 100]"
                    :page-size="limit"
                    background
                    :hide-on-single-page="false"
                    layout="sizes, prev, pager, next,jumper"
                    :total="total">
                  </el-pagination>
                </div>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="附件作业" name="HOMEWORK_FILE">
              <el-row>
                <el-table
                  :data="tableData_file"
                  border
                  style="width: 100%">
                  <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingName" header-align="center" align="center" label="附件作业名称"  width="180"> </el-table-column>
                  <el-table-column prop="messageAddTime" header-align="center" align="center" label="作业附件" width="120">
                    <template slot-scope="scope">
                      <template v-if="!$isEmpty(scope.row.teacherOpenCourseQuestionSettingFile)">
                        <el-link type="primary" @click="downLoadInfo(scope.row)" :underline="false" >下载</el-link>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="time" header-align="center" align="center" label="作业时间">
                    <template slot-scope="scope">
                        {{scope.row.teacherOpenCourseQuestionStartTime}} ~ {{scope.row.teacherOpenCourseQuestionEndTime}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="messageAcceptState" header-align="center" align="center" label="状态" width="120">
                    <template slot-scope="scope">
                      <span :class="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?'':'red'">
                        {{scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?"发布":"未发布"}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="fileQuestionInfo.studentScore" header-align="center" align="center" label="得分"  width="120"> </el-table-column>
                  <el-table-column prop="fileQuestionInfo.teacherOpenCourseQuestionLogReply" header-align="center" align="center" label="教师评语"> </el-table-column>
                  <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="160">
                    <template slot-scope="scope">
                      <el-link type="primary" :underline="false" :disabled="!$isEmpty(scope.row.fileQuestionInfo) && !$isEmpty(scope.row.fileQuestionInfo.studentScore)" @click="submitHomework(scope.row)">
                        <template v-if="$isEmpty(scope.row.fileQuestionInfo) || $isEmpty(scope.row.fileQuestionInfo.teacherOpenCourseQuestionLogUploadFile)">
                          提交作业
                        </template>
                        <template v-else>
                          <span style="color: red;">重新提交</span>
                        </template>
                      </el-link>
                      <el-link v-if="!$isEmpty(scope.row.fileQuestionInfo) && !$isEmpty(scope.row.fileQuestionInfo.teacherOpenCourseQuestionLogUploadFile)" type="primary"  @click="$downLoadFile(scope.row.fileQuestionInfo.teacherOpenCourseQuestionLogUploadFile,scope.row.teacherOpenCourseQuestionSettingName)" target="_blank" :underline="false">下载</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
                  <el-pagination
                    @size-change="handleSizeChange_file"
                    @current-change="handleCurrentChange_file"
                    :current-page.sync="currentPage1_file"
                    :page-sizes="[8, 20, 50, 100]"
                    :page-size="limit_file"
                    background
                    :hide-on-single-page="false"
                    layout="sizes, prev, pager, next,jumper"
                    :total="total_file">
                  </el-pagination>
                </div>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-row>

        <!-- 提交作业对话框 -->
        <el-dialog
          title="提交作业"
          :visible.sync="homewordk_dialog"
          class="dialog_"
          width="700px">
          <el-form label-width="80px">
            <el-form-item label="作业名称：">
              {{homeInfo.teacherOpenCourseQuestionSettingName}}
            </el-form-item>
            <el-form-item label="作业要求：">
              <el-row v-html="homeInfo.teacherOpenCourseQuestionSettingRequire"></el-row>
            </el-form-item>
            <el-form-item label="提交作业：">
              <UploadFiles
                ref="taskPicture"
                :limit="1"
                :fileLists="teacherOpenCourseQuestionSettingFileList"
                v-if="homewordk_dialog"
                @onSuccess="infoSuccess"
              />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="homewordk_dialog = false">取 消</el-button>
            <el-button type="primary" @click="submitHomeworkInfo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import UploadFiles from "@/components/UploadFiles";	//上传
export default {
  name: 'Homework',
  components: {
    UploadFiles
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      activeName: 'HOMEWORK_QUESTION', //HOMEWORK_QUESTION:作业-题目类型 HOMEWORK_FILE:作业-附件类型
      tableData:[],  //题库作业
      tableData_file:[], //附件作业

      total: 0,
      limit:8,
      page:1,
      currentPage1_file: 1,
      total_file: 0,
      limit_file:8,
      page_file:1,
      homewordk_dialog:false, //提交作业show
      teacherOpenCourseQuestionSettingFileList:[],
      homeInfo:{}
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    handleClick(){
      if(this.tableData_file.length <= 0 || this.tableData.length <= 0){
        this.getInfo();
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },handleSizeChange_file(val) {
      console.log(`每页 ${val} 条`);
      this.limit_file = val;
      this.getInfo();
    },
    handleCurrentChange_file(val) {
      console.log(`当前页: ${val}`);
      this.page_file = val;
      this.getInfo();
    },
    getInfo(){ //获取列表
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        teacherOpenCourseQuestionSettingType:this.activeName
      }
      if(this.activeName == "HOMEWORK_FILE"){ //HOMEWORK_QUESTION:作业-题目类型 HOMEWORK_FILE:作业-附件类型
        param.limit = this.limit_file;
        param.page = this.page_file;
      }
      this.$post("/api/teacherOpenCourseQuestionSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          if(this.activeName == "HOMEWORK_FILE"){
            this.total_file = Number(ret.count);
            this.tableData_file = ret.data;
          }else{
            this.total = Number(ret.count);
            this.tableData = ret.data;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    homeworkDetails(item){ //查看成绩
      this.$router.push({name:'HomeworkDetails',query:{type:2,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId,chapterId:item.teacherOpenCourseMergeCourseInfoId}});
    },
    startHomework(item,type){ //开始作业 type:1作业 2:详情
      this.$router.push({name:'HomeworkStart',query:{type:1,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId,chapterId:item.teacherOpenCourseMergeCourseInfoId}});
    },
    submitHomework(item){ //提交附件作业
      this.teacherOpenCourseQuestionSettingFileList = [];
      this.homeInfo = item;
      this.homewordk_dialog = true;
    },
    submitHomeworkInfo(){
      if(this.teacherOpenCourseQuestionSettingFileList.length <= 0){
        this.$message.warning("请上传作业附件！");
        return;
      }
      let param = {
        questionSettingId: this.homeInfo.teacherOpenCourseQuestionSettingId,
        questionLogMap: {uuid: this.teacherOpenCourseQuestionSettingFileList[0].fileUrl},
        addTime:this.$getNewDate()
      }
      this.$postJSON('/api/teacherOpenCourseQuestionLog/addQuestionLog.do',param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.homewordk_dialog = false;
          this.$message({type: 'success',message: '提交成功！'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    infoSuccess(file){ //上传成功回调
      this.teacherOpenCourseQuestionSettingFileList = [];
      for(let i in file){
        this.teacherOpenCourseQuestionSettingFileList.push(
        {
          fileName:file[i].name,
          fileUrl:file[i].url,
        });
      }
    },
    downLoadInfo(item){ //下载
      let list = JSON.parse(item.teacherOpenCourseQuestionSettingFile);
      this.$downLoadFile(list[0].fileUrl,list[0].fileName);
    }
  }
};
</script>
<style  lang="less">
  .course_Homework{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .el-tabs__nav-wrap::after{
        background-color:white;
      }
      .user_discuss_img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
    .tl_list{
      border-bottom: 1px solid #DEDEDE;padding: 20px 20px 20px 0;
    }
    .tl_list:last-child{
      border-bottom:none;
    }
    .el-form-item__label{
      width: 100px !important;
    }
    .el-form-item__content{
      margin-left: 100px !important;
    }
    .el-form-item{
      margin-bottom: 10px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/Homework.vue